import React from 'react';

import '../../../css/components/batches/ManagementFiltersModal.css';

import ManagementFiltersForm from './ManagementFiltersForm';
import Traductor from '../../Traductor';

const ManagementFiltersModal = ({ filters, onChangeFilters, onClose }) => {
    const t = new Traductor();
    return (
        <div className="c-modal  " aria-hidden="false">
            <div
                className="c-modal__overlay  js-modal-close"
                tabIndex="-1"
            ></div>
            <div
                className="c-modal__wrapper u-modal-wrapper-retransform u-ph u-pb"
                role="dialog"
                aria-labelledby="c-modal-management-title"
            >
                <header className="c-modal__header">
                    <div className="c-modal__title__wrapper u-align-start">
                        <h1
                            className="c-modal__title"
                            id="c-modal-management-title"
                        >
                            {t.getTraduction('Filters')}
                        </h1>
                    </div>
                    <button
                        className="c-modal__close-btn  js-modal-close"
                        type="button"
                        aria-label="Close management filters modal icon"
                        onClick={onClose}
                    />
                </header>
                <ManagementFiltersForm
                    filters={filters}
                    onClose={onClose}
                    onSubmit={onChangeFilters}
                />
            </div>
        </div>
    );
};

export default ManagementFiltersModal;
